import { ApiService, GenericError} from './api-main'
import { f7 } from 'framework7-vue';
import TokenService from './token-service'
import CryptoAES        from 'aes-ecb'
import store            from '../store';

const RegistrationService = {
    getCountryList: async function() {
        const param = {
        }

        const url = 'main/country'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, param)
            // console.log(response)

            return ApiService.validateResponse(response, '1009')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },
    getTnc: async function(applId) {
        ApiService.setCustomHeader(0, "", "");

        const isAxsrState = store.state.registration.isAxsr;

        var appId = (applId > 0) ? applId : ((isAxsrState) ? process.env.VUE_APP_AXS_APP_ID : process.env.VUE_APP_APP_ID);
        var raId =  process.env.VUE_APP_RETAIL_AGENT_ID

        const url = 'main/tnc/' + appId + '/retailagent/' + raId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)

            return ApiService.validateResponse(response, '3300')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getRecaptchaKey: async function() {
        const url = 'main/recaptcha'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {});
            /*if(response.data.status == "1223"){
                return response.data.result.siteKey;
            }*/
            return response.data;
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getTokenSingpass: async function() {
        console.log("getTokenSingpass service, is AXS ? "+store.state.registration.isAxsr)
        var referralCode = encodeURIComponent(store.state.registration.referral);
        var refParam = "";
        if(referralCode != ""){
            refParam = '&referrer='+encodeURI(referralCode);
        }
        const ipAddress = ""
        const url = 'main/register/new/0?ipAddress='+ipAddress+refParam+'&rbId='+store.state.misc.appBranchId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {});
            if(response.data.status == "WN00103"){
                TokenService.saveToken(response.data.result.token, f7.device.desktop);
            }
            return response.data;
        } catch (e) {
            console.log(e)

            if (e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getToken: async function(registrationData) {
        var referralCode = encodeURIComponent(store.state.registration.referral);
        var refParam = "";
        if(referralCode != ""){
            refParam = '&referrer='+encodeURI(referralCode);
        }

        var tokenParam = "";
        if(registrationData.isSingpass!= undefined) {
            tokenParam = '&token='+TokenService.getToken();
        }

        const url = 'main/register/new/1?email='+registrationData.email+'&password='+encodeURIComponent(registrationData.password)+refParam+'&recaptcha='+registrationData.recaptcha+'&recaptchaV2='+registrationData.recaptchaV2+'&rbId='+store.state.misc.appBranchId+tokenParam

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {});
            if(response.data.status == "WN00103"){
                TokenService.saveToken(response.data.result.token, f7.device.desktop);
            }
            return response.data;
        } catch (e) {
            console.log(e)

            if (e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getTokenByGoogleAppleSignIn: async function(registrationData) {
        const referralCode = store.state.registration.referral;
        let refParam = "";
        if(referralCode != ""){
            refParam = '&referrer='+referralCode;
        }
        const url = 'main/register/new/1?token='+TokenService.getToken()+'&password='+encodeURIComponent(registrationData.password)+refParam+'&rbId='+store.state.misc.appBranchId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {});
            if(response.data.status == "WN00103"){
                TokenService.saveToken(response.data.result.token, f7.device.desktop);
            }
            return response.data;
        } catch (e) {
            console.log(e)

            if (e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    registerNew2: async function(registrationData) {
        ApiService.setCustomHeader(6, TokenService.getToken(), "");

        const encodedAlias = encodeURIComponent(registrationData.customerAlias);
        const url = 'main/register/new/2?mobilePhone='+registrationData.mobileNum+'&mobilePhoneCountryId='+registrationData.mobileCountryId+'&alias='+encodedAlias

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {});
            //console.log("result registerNew2 : ", response)


            if (response.data.status == '4000'){
                ApiService.saveFormData("uuid",response.data.result.uuid);
                ApiService.saveFormData("prefix",response.data.result.prefix);
                ApiService.saveFormData("otpIDD",response.data.result.otpIDD);
                ApiService.saveFormData("otpMobilePhone",response.data.result.otpMobilePhone);
            }

            return response.data;
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },
    registerNew3: async function(otp) {
        //console.log("otp: ", otp);
        //console.log("uuid: "+ApiService.getFormData("uuid"))

        // var today = new Date();
        // var dd = String(today.getDate()).padStart(2, '0');
        // var MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        // var yy = today.getFullYear().toString().substr(-2);
        // var todayNew = MM + dd + yy;
        const randVal = await ApiService.getRandomValue();
        var secretKeyOTP  = process.env.VUE_APP_OPSTK+randVal;

        var encryptedOTP = CryptoAES.encrypt(secretKeyOTP, otp);
        var accessToken = TokenService.getToken()
        ApiService.setCustomHeader(9, accessToken, encodeURIComponent(encryptedOTP));

        const url = 'main/register/new/3'

        const param = {
        }

        try {
            await ApiService.generateAuthClient(randVal);
            const response = await ApiService.get(url, param);
            //console.log("result registerNew3 : ", response)
            if(response.data.status == "WN00108"){
                //console.log("new token: "+response.data.result.access_token);
                var now = new Date();
                var expiryTime = new Date(now.getTime() + (response.data.result.expires_in * 1000));

                TokenService.saveToken(response.data.result.access_token, f7.device.desktop);
                TokenService.saveTokenExpiry(expiryTime, f7.device.desktop);
                if(response.data.result.passReq != undefined) {
                    ApiService.saveFormData("passReq", response.data.result.passReq);
                }

                store.commit('auth/loggedIn', response.data.result.access_token);
                //store.state.auth.loggedIn = true;
            }
            return response.data;
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    acceptTnc: async function() {
        var appId = process.env.VUE_APP_APP_ID;

        ApiService.setCustomHeader(2, TokenService.getToken(), "");

        const url = 'main/customer/tnc/' + appId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.put(url, {})
            //console.log("acceptTnc :", response);
            return response.data;
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
            return false;
        }
    },

    getTNCVersion: async function() {
        const url = 'main/version/current'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})

            return ApiService.validateResponse(response, '20000')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getRegisterMyInfoUrl: async function(isUsingInAppBrowser) {
        //console.log("token: "+TokenService.getToken());
        ApiService.setCustomHeader(6, TokenService.getToken(), "");

        var url = 'main/register/myinfo/url?rbId='+store.state.misc.appBranchId
        if(isUsingInAppBrowser) {
            url += '&version=1';
        }
        url += ApiService.getMyinfoSignalQuery(); // DR-1931: forward osName/appVersion for v5 routing

        let params = {}
        const isAxsrState = store.state.registration.isAxsr;
        console.log("getRegisterMyInfoUrl service : is AXS ? "+isAxsrState);
        if(isAxsrState){
            params.client_id = process.env.VUE_APP_AXSR_CLIENT_ID
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            //console.log("getMyInfoUrl: ", response)
            return ApiService.validateResponse(response, '4856')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getRegisterMyInfoDetail: async function(isUsingInAppBrowser, myInfoCode, myInfoState) {
        ApiService.setCustomHeader(8, "", "");
        //console.log(myInfoCode + " ## " + myInfoState)


        const token             = TokenService.getToken();
        const encodedCode       = encodeURIComponent(myInfoCode);
        const encodedState      = encodeURIComponent(myInfoState);

        //console.log("encodedCode: "+encodedCode+" # encodedState: "+encodedState);

        var url = 'main/myinfo/landing?code='+encodedCode+'&state='+encodedState+'&token='+token+'&rbId='+store.state.misc.appBranchId;
        if(isUsingInAppBrowser) {
            url += '&version=1';
        }

        let params = {}
        const isAxsrState = store.state.registration.isAxsr;
        if(isAxsrState){
            params.client_id = process.env.VUE_APP_AXSR_CLIENT_ID
        }

        try {
            const response = await ApiService.get(url, {params})
            //console.log("getRegisterMyInfoDetail: ", response)
            return response.data;
            //return ApiService.validateResponse(response, '4854')
        } catch(e) {
            console.log("getRegisterMyInfoDetail e: ", e);
            if(e instanceof GenericError) {
                throw e
            }
            return false
        }


        //const testResult = {"status":"4854","message":"Successfully Get Customer By MyInfo","result":{"enabledField":"6,7,8,10","name":"ANDY LAU","gender":"M","dateOfBirth":"Oct 6, 1988 12:00:00 AM","residentialStatusId":2,"residentialStatus":"Citizen","nationalityId":189,"nationality":"SINGAPORE CITIZEN","identificationTypeId":216,"identificationType":"National ID Card","identificationNo":"S6005048A","idStatusLive":false,"idStatus":"","industryId":0,"industry":"","email":"test01@test.com","emailVerified":true,"address":{"streetAddress":"319, 38-10, ANCHORVALE DRIVE","postcode":"542319","cityId":0,"provinceId":0,"countryId":189,"country":"SG","buildingNumber":"319","streetName":"ANCHORVALE DRIVE","buildingName":"","unitNumber":"38-10"},"employer":"","occupationId":0,"occupation":"","poa":true}};
        //const testResult = {"status":"9090","message":"Successfully get myinfo details","result":{"identificationNo":"G1613350M","fullName":"John Denver","gender":"Male","dob":{"year":1994,"month":10,"dayOfMonth":4},"residentialStatus":"Permanent Resident","nationalityId":99,"nationality":"Indonesia","passType":"Overseas Networks & Expertise Pass","passStatus":"LIVE","passExpiryDate":{"year":2024,"month":12,"dayOfMonth":7},"employmentSector":"Tourism","email":"johndenver@gmail.com","address":"Yishun St B1 B24","employerName":"Pay2home pte ltd","occupation":"Chief Technology Officer"}};
        //return testResult;
    },

    registerMyInfoUpdate: async function(isUsingInAppBrowser) {
        ApiService.setCustomHeader(8, TokenService.getToken(), "");

        let axiosHeader = {
            headers: {

            }
        }

        const dobVal = store.state.myinfo.dob;
        console.log("dobVal = "+dobVal);
        /*var d = new Date(dobVal),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

          if (month.length < 2) { month = '0' + month; }
          if (day.length < 2) { day = '0' + day; }

        const newDate = [year, month, day].join('-');
        */
        const dobArr = dobVal.split("-");
        const year = dobArr[2];
        const month = dobArr[1];
        const day = dobArr[0];

        const newDate = [year, month, day].join('-');

        let param = {
            firstName     : store.state.myinfo.fullName,
            identificationNo     : store.state.myinfo.identificationNo,
            gender     : (store.state.myinfo.gender == "Male" ? "M" : "F"),
            nationalityId     : store.state.myinfo.nationalityId,
            dob     : newDate,
            email     : store.state.myinfo.email,
            occupation     : store.state.myinfo.occupation,
            industry     : store.state.myinfo.employmentSector,
            address     : store.state.myinfo.address,
            employer     : store.state.myinfo.employerName,
            myinfoToken     : store.state.myinfo.myInfoState,
        }

        const isAxsrState = store.state.registration.isAxsr;
        if(isAxsrState){
            param.client_id = process.env.VUE_APP_AXSR_CLIENT_ID
        }

        var url = 'main/register/myinfo/update?rbId='+store.state.misc.appBranchId
        if(isUsingInAppBrowser) {
            url += '&version=1';
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customHeader(url, param, axiosHeader)
            console.log("registerMyInfoUpdate: ", response);
            return response.data
        } catch(e) {
            console.log("update myInfor error: ",e)
            /*console.log("modifyBeneError: " + JSON.stringify(e))
            modifyBene.invalid = true;
            if(e.response.data.status == '90008') { // Access token has expired
                modifyBene.message = "otp-invalid-text-8"
            }
            return modifyBene
            */
        }
    },

    activateEVC: async function() {
        ApiService.setCustomHeader(8, "", "");

        const emailId  = store.state.registration.emailId;
        const emailEVC = store.state.registration.emailEVC;
        const newEmail = store.state.registration.email;

        //const token             = TokenService.getToken();
        const encodedID         = encodeURIComponent(emailId);
        const encodedEVC        = encodeURIComponent(emailEVC);
        const encodedNewEmail   = encodeURIComponent(newEmail);

        //console.log("encodedID: "+encodedID+" # encodedEVC: "+encodedEVC);

        var url = 'main/activateEVC?id='+encodedID+'&evc='+encodedEVC;
        if(newEmail != '') {
            url += '&ne=' + encodedNewEmail;
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            //console.log("activateEVC: ", response)
            return response.data;
        } catch(e) {
            //console.log("activateEVC e: ", e);
            if(e instanceof GenericError) {
                throw e
            }
            return false
        }
    },
}

export default RegistrationService